var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.36851L1.69486 3.9176C1.47871 3.69413 1.12826 3.69413 0.912111 3.91761C0.695961 4.14108 0.695963 4.5034 0.912115 4.72687L5.60863 9.5824C5.82478 9.80587 6.17522 9.80587 6.39137 9.5824L11.0879 4.72687C11.304 4.5034 11.304 4.14108 11.0879 3.91761C10.8717 3.69413 10.5213 3.69413 10.3051 3.9176L6 8.36851Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/Chevron.3feaac3b.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.36851L1.69486 3.9176C1.47871 3.69413 1.12826 3.69413 0.912111 3.91761C0.695961 4.14108 0.695963 4.5034 0.912115 4.72687L5.60863 9.5824C5.82478 9.80587 6.17522 9.80587 6.39137 9.5824L11.0879 4.72687C11.304 4.5034 11.304 4.14108 11.0879 3.91761C10.8717 3.69413 10.5213 3.69413 10.3051 3.9176L6 8.36851Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/Chevron.3feaac3b.svg";
export { ForwardRef as ReactComponent };